import React, { useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

type Props = {
  id: string;
  action: React.Dispatch<any>;
  initialInView?: boolean;
  children: React.ReactNode;
};

export const Waypoint: React.FC<Props> = ({
  id,
  action,
  initialInView = false,
  children,
}) => {
  const { ref: ref, inView: isVisible } = useInView({
    rootMargin: '-250px 0px -250px 0px',
    initialInView,
  });

  useEffect(() => {
    if (isVisible) {
      action(id);
    }
  }, [isVisible]);

  return <section ref={ref}>{children}</section>;
};
